module.exports = __webpack_public_path__ + "img/magento-support-security_medium@2x.2a8a9ffd.webp";